export enum AcquisitionStrategy {
    Default,
    PreviousStep,
    Spot
}